import React from 'react';
import Hero from '../components/Hero';
import {Link} from 'react-router-dom';

const SingleProductPage = () => {
    return (
        <div>
            single
        </div>
    );
};

export default SingleProductPage;